import { render, staticRenderFns } from "./PortalRefundStep.vue?vue&type=template&id=bf1e4466"
import script from "./PortalRefundStep.vue?vue&type=script&lang=js"
export * from "./PortalRefundStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports